import { render } from "./CGMemberView.vue?vue&type=template&id=25a8e6d1&scoped=true"
import script from "./CGMemberView.vue?vue&type=script&lang=js"
export * from "./CGMemberView.vue?vue&type=script&lang=js"

import "./CGMemberView.vue?vue&type=style&index=0&id=25a8e6d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a8e6d1"]])

export default __exports__